import Vue from 'vue'
import strings from '@/strings'
import i18n from '@/i18n'
import qs from 'qs'
import storage from '@/utils/storage'
import EventBus from 'login/EventBus'

const proto = Vue.prototype

export default {
  isPresentDay (date) {
    let onlyDate = date.clone().startOf('day').isSame(proto.$moment().startOf('day'))
    return onlyDate
  },
  isBetweenAndSame (id, firtsTime, secondTime) {
    let time = proto.$moment(id, proto.$moment.defaultFormat)
    if (time.isSame(firtsTime) || time.isSame(secondTime) || time.isBetween(firtsTime, secondTime) || time.isBetween(secondTime, firtsTime)) {
      return true
    } else {
      return false
    }
  },
  processMessageSingleOrPlural (message, array) {
    message += (array.length > 1 ? 'Plural' : 'Single')
    return message
  },
  concatArrayWithComma (array) {
    if (array.length === 1) {
      return array[0]
    }

    var currentLocation = proto.$languages().locale
    var currentLanguage = proto.$languages().messages[currentLocation]
    var and = currentLanguage.and.toLowerCase()

    return [array.slice(0, -1).join(', '), array.slice(-1)[0]].join(array.length < 2 ? '' : ` ${and} `)
  },
  hasIntersection (dateStart, dateEnd, rangeUsedStart, rangeUsedEnd) {
    if (dateStart > dateEnd) {
      let tmp = dateStart
      dateStart = dateEnd
      dateEnd = tmp
    }
    if ((dateStart <= rangeUsedStart) && (rangeUsedEnd <= dateEnd)) {
      return true
    }
    // Range intersects with other start ?
    if ((dateStart <= rangeUsedStart) && (rangeUsedStart <= dateEnd)) {
      return true
    }
    // Range intersects with other end ?
    if ((dateStart <= rangeUsedEnd) && (rangeUsedEnd <= dateEnd)) {
      return true
    }

    if ((dateStart >= rangeUsedStart) && (dateEnd <= rangeUsedEnd)) {
      return true
    }

    // All good
    return false
  },
  _map (list) {
    if (list && list.length > 0) {
      return list.reduce((map, obj) => {
        map[obj.id] = obj
        return map
      }, {})
    } else {
      return {}
    }
  },
  _toLower (text) {
    if (text) {
      return text.toString().toLowerCase()
    } else {
      return ''
    }
  },
  getDefaultSteps (route) {
    return strings.steps[route]
  },
  getRoomStatus (value) {
    var result = 'unavailable'
    if (strings.uiConfig.cardConfigurations && value.bookable) {
      for (var i of strings.uiConfig.cardConfigurations) {
        if (i.booked === value.booked && i.busy === value.busy && i.hasSensor === value.hasSensor) {
          result = i.status
          break
        }
      }
    }
    return result
  },
  getImageFromApi (response) {
    let image = 'data:image/jpeg;base64,'
    image = image + btoa(
      new Uint8Array(response.data)
        .reduce((data, byte) => data + String.fromCharCode(byte), '')
    )
    return image
  },
  getClosestVueParent ($parent, cssClass) {
    if (!$parent || !$parent.$el) {
      return false
    }

    if ($parent._uid === 0) {
      return false
    }

    if ($parent.$el.classList.contains(cssClass)) {
      return $parent
    }

    return this.getClosestVueParent($parent.$parent, cssClass)
  },
  isRangeBetweenAndSame (dateStart, dateEnd, rangeUsedStart, rangeUsedEnd) {
    if (dateStart > dateEnd) {
      let tmp = dateStart
      dateStart = dateEnd
      dateEnd = tmp
    }
    if ((dateStart <= rangeUsedStart) && (rangeUsedEnd <= dateEnd)) {
      return true
    }
    if ((dateStart >= rangeUsedStart) && (dateEnd <= rangeUsedEnd)) {
      return true
    }

    // All good
    return false
  },
  getNearestInterval (minutes) {
    var ROUNDING = minutes * 60 * 1000
    var start = proto.$moment()
    start = proto.$moment(Math.ceil((start) / ROUNDING) * ROUNDING).second(0)
    return start
  },
  timeOut (func, params, delay, timeOut) {
    let args = params ? [...params] : arguments
    let callFunction = function () {
      func.apply(null, args)
    }
    if (timeOut) {
      clearTimeout(timeOut)
    }
    let timeOutId = setTimeout(() => {
      callFunction()
    }, delay)
    return timeOutId
  },
  formatMoney (amount, decimal, thousands) {
    let decimalCount = Math.abs(2)
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount

    const negativeSign = amount < 0 ? '-' : ''

    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString()
    let j = (i.length > 3) ? i.length % 3 : 0

    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '')
  },
  getJwtClaim (token, key) {
    let claim = token ? this.parseJWTToken(token)[key] : null
    return claim
  },
  parseJWTToken (token) {
    let base64Url = token.split('.')[1]
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    let jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))
    return JSON.parse(jsonPayload)
  },
  handleDownload (blob, filename) {
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = filename
    a.click()
    URL.revokeObjectURL(url)
  },
  getFileName (contentDisposition) {
    return contentDisposition.split(';').find(c => c.includes('filename=')).replace('filename=', '').replace(/"/g, '').trim()
  },
  sortByKey (key) {
    return function (a, b){
      if (a[key] > b[key]) {
        return 1
      }
      if (b[key] > a[key]) {
        return -1
      }
      return 0
    }
  },
  sortByKeyOrder (key, order) {
    return function (a, b){
      if (a[key] === null) {
        return order === 'desc' ? -1 : 1
      }
      if (b[key] === null) {
        return order === 'desc' ? 1 : -1
      }
      if (a[key] > b[key]) {
        return order === 'desc' ? -1 : 1
      }
      if (b[key] > a[key]) {
        return order === 'desc' ? 1 : -1
      }
      return 0
    }
  },
  charactersLimit (str, charactersLimit ) {
    if (str.length > charactersLimit) {
      return false
    }
    return str.toLowerCase()
  },
  getItemDisplay (state, objectKey) {
    return state.name ? state.name : state[objectKey]
  },
  eventName(item, title, owner, room, userEmail, hasHideBookingTitles, isAdminForEventName){
    let ownerToCompare = this._toLower(owner)
    let userEmailToCompare = this._toLower(userEmail)
    if (item.eventTypeId == strings.eventTypeIntervalLockId) {
      return i18n.t('blocked')
    } else if (item.isPrivateEvent && (ownerToCompare !== userEmailToCompare)) {
      return i18n.t('privateEvent') + ' (' + owner + ')'
    } else if (hasHideBookingTitles && ownerToCompare !== userEmailToCompare && !item.attendees.includes(userEmailToCompare) && !isAdminForEventName){
      if(room.isCombinedRoom && !item.isCombinedRoomEvent){
        return i18n.t('hasBooking')
      } else{
        return i18n.t('hasBooking') + ' (' + owner + ')'
      }
    }  else if (room.isCombinedRoom && !item.isCombinedRoomEvent) {
      return i18n.t('hasBooking')
    } else if (!title) {
      return i18n.t('noTitle') + ' (' + owner + ')'
    } else if (!item.blocked) {
      return title + ' (' + owner + ')'
    } else {
      return title
    }
  },
  generateHashFromString(str){
    return str.split('').reduce((prevHash, currVal) =>
      (((prevHash << 5) - prevHash) + currVal.charCodeAt(0))|0, 0);
  },
  getCurrentDate () {
    return proto.$moment().format(proto.$moment.HTML5_FMT.DATE)
  },
  checkIfArrayHasFilterOptionsInterception(array, filters){
    return filters.every(filter => {
      return array.includes(filter)
    })
  },
  debounce (func, params, delay, timeOut) {
    let args = params ? params : arguments
    let callFunction = function () {
      func.apply(null, [args])
    }
    if (timeOut) {
      clearTimeout(timeOut)
    }
    let timeOutId = setTimeout(() => {
      callFunction()
    }, delay)
    return timeOutId
  },
  getDateTwelveMonthsAgo () {
    return proto.$moment().subtract(1, 'year').date(1).format(proto.$moment.HTML5_FMT.DATE)
  },
  generateQueryString(filters, isFile){
    let config = {
      responseType: '',
      params: filters,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }

    if(isFile){
      config.responseType = 'arraybuffer'
    }
    return config
  },
  checkNPS(journey){
    const version = process.env.VUE_APP_BUILD_NUMBER
    let journeySession = storage.getFromLocalStorage('NPSVersion')
    if(!journeySession || journeySession < version){
      storage.saveToLocalStorage('NPSCurrentJourney', {
        journey: journey,
        version
      })
    }
  },
  checkPendingNPSAndOpen(){
    let currentJourney = storage.getFromLocalStorage('NPSCurrentJourney')
    if(currentJourney){
      EventBus.publish("openNPS")
    }
  },
  getMinutesDiffBetweenWorkingDays(start, end) {
    if (start.isSame(end, 'day')) { return end.diff(start, 'm') }

    const weekend = [0,6];
    let minutes = 0;
    let currentDay = start.clone().add(1, 'day').startOf('day')

    minutes += currentDay.diff(start, 'm')

    while(currentDay.isBefore(end)) {
      if (weekend.includes(currentDay.day())) {
        currentDay.add(1, 'days')
        continue
      }
      
      if (currentDay.isSame(end, 'day')) {
        minutes += end.diff(currentDay, 'm')
        break
      }

      let nextDay = currentDay.clone().add(1, 'days')
      minutes += nextDay.diff(currentDay, 'm')

      currentDay = nextDay;
    }

    return minutes
  },
  convertMinutesToMilliseconds(minutes) {
    return minutes * 60 * 1000
  },
  getEventsWithIntervalLock(room) {
    if (!room.hasIntervalLock) {
      return room.events
    }

    let events = []

    for(const event of room.events) {
      if (proto.$moment(event.startDate) < proto.$moment()) { continue }

      const lastIntervalLock = events.findLast(e => e.eventTypeId == strings.eventTypeIntervalLockId)
      const startDate = proto.$moment(event.startDate).subtract(room.intervalLockInMinutes, 'minutes')
      const endDate = proto.$moment(event.startDate)

      if (lastIntervalLock && this.hasIntersection(startDate, endDate, proto.$moment(lastIntervalLock.startDate), proto.$moment(lastIntervalLock.endDate))) {
        events.pop()

        events.push({
          endDate: endDate.format(proto.$moment.HTML5_FMT.DATETIME),
          startDate: proto.$moment(lastIntervalLock.startDate).format(proto.$moment.HTML5_FMT.DATETIME),
          eventTypeId: strings.eventTypeIntervalLockId
        })
      } else {
        events.push({
          endDate: endDate.format(proto.$moment.HTML5_FMT.DATETIME),
          startDate: startDate.format(proto.$moment.HTML5_FMT.DATETIME),
          eventTypeId: strings.eventTypeIntervalLockId
        })
      }

      events.push(event)

      events.push({
        startDate: event.endDate,
        endDate: proto.$moment(event.endDate).add(room.intervalLockInMinutes, 'minutes').format(proto.$moment.HTML5_FMT.DATETIME),
        eventTypeId: strings.eventTypeIntervalLockId
      })
    }

    return events;
  }
}
